import { Component, inject } from '@angular/core';
import { LayoutComponent } from './components/layout/layout.component';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from '../environments/environment';

// global.d.ts or at the top of your file
type Gtag = {
  (
    command: 'config',
    gaCode: string,
    config?: {
      page_path?: string;
      [key: string]: unknown;
    },
  ): void;
  (
    command: 'event',
    eventName: string,
    eventParams?: {
      [key: string]: unknown;
    },
  ): void;
  (command: 'set', params: { [key: string]: unknown }): void;
};

declare let gtag: Gtag;

@Component({
  selector: 'app-root',
  imports: [LayoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  gaCode: string = environment.googleAnalyticsId;
  private readonly router = inject(Router);

  constructor() {
    if (this.gaCode !== '') {
      const navEndEvents = this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
      );
      navEndEvents.subscribe((event: NavigationEnd) => {
        gtag('config', this.gaCode, {
          page_path: event.urlAfterRedirects,
        });
      });
    } else if (environment.production) {
      console.warn('Google Analytics gtag function not available');
    }
  }
}
